import _, { groupBy } from 'lodash';
import { useEffect, useState } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import useFetch from 'use-http';
import SearchIcon from '../../../assets/icons/search.svg?react';
import { useSettingsState } from '../../context/SettingsContext';
import Container from '../Container';
import Loader from '../Loader';
import Styled from './Hero.styles';
import PopularSearches from './PopularSearches';
import Search from './Search';
import useIsMobile from '../../hooks/useIsMobile';

function highlightText(text, search) {
  const re = new RegExp(`(${_.escapeRegExp(search)})`, 'gi');
  const newResults = text.replace(re, '<mark>$&</mark>');
  return newResults;
}

const Hero = ({ onScroll }) => {
  const { t } = useTranslation();
  const { theme } = useSettingsState();
  const isMobile = useIsMobile();
  const history = useHistory();

  const [query, setQuery] = useState('');
  const [lastQuery, setLastQuery] = useState('');
  const [results, setResults] = useState({});
  const [allowShowEmptyResults, setAllowShowEmptyResults] = useState(false);
  const searchInputReplaceRegex = /[^a-zA-Z0-9ąčęėįšųūžĄČĘĖĮŠŲŪŽ\s():-]/g;
  const {
    get: fetchSearchResults,
    response: fetchSearchResultsResponse,
    loading: fetchSearchResultsLoading,
  } = useFetch('/Services/ServicesBySearch');
  const { request: logUserSearchResultsSelectionRequest } = useFetch(
    '/UserSearchManagement/searchResultSelectionLog',
  );
  const { request: complexServiceRequest } = useFetch(
    '/Services/CombinedServices',
  );

  const isUltrasoundServiceType = (service) =>
    service.serviceTypeExternalId ==
    process.env.REACT_APP_ULTRASOUND_SERVICE_TYPE_EXT_ID;

  const getAllowed = () => {
    const ls = localStorage.getItem('cookies');
    return ls ? ls.split(',') : [];
  };

  const redirectToServicePage = (service) => {
    const url = `?serviceId=${service.serviceId}&holter=${service.isHolter}`;

    complexServiceRequest.get(url).then((r) => {
      if (r?.length !== 1) {
        return;
      }
      var complexService = r[0];

      logUserSearchResultsSelection(
        service.serviceId,
        service.workplaceId,
        lastQuery,
        url,
      ).finally(() => {
        history.push('/kompleksines-paslaugos/checkout', {
          service: complexService.service,
          prices: complexService.prices,
          selectedDepartment: undefined,
        });
      });
    });
  };

  useEffect(() => {
    setAllowShowEmptyResults(false);
    const timer = setTimeout(() => {
      if (query) {
        const replacedQuery = query.replace(searchInputReplaceRegex, '');

        if (!replacedQuery || replacedQuery.trim().length < 3) {
          return;
        }

        setLastQuery(replacedQuery);
        const encodedQuery = encodeURIComponent(replacedQuery);
        fetchSearchResults(`?Search=${encodedQuery}`).then((r) => {
          if (!fetchSearchResultsResponse.ok) {
            setResults({});
            return;
          }

          setAllowShowEmptyResults(true);
          r.sort((a, b) => {
            return (
              (b.hasUpcomingVisits === true) - (a.hasUpcomingVisits === true)
            );
          });
          setResults(replacedQuery ? groupBy(r, 'serviceTypeTitle') : {});
        });
      } else {
        setResults({});
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [query, fetchSearchResults, fetchSearchResultsResponse]);

  const getSearchSelectedTitleForGA = (service) => {
    return !service.specialistId
      ? service?.serviceTitle
      : service?.specialistName + ' - ' + service?.serviceTitle;
  };

  const logUserSearchResultsSelection = async (
    serviceId,
    workplaceId,
    query,
    url,
  ) => {
    try {
      await logUserSearchResultsSelectionRequest.post('', {
        serviceId,
        workplaceId,
        searchPhrase: query,
        SelectedResultUrl: url,
      });
      // response ignored
    } catch (err) {}
  };

  return (
    <Styled.Hero
      primaryColor={theme.primaryColor}
      // style={{
      //   backgroundImage: `url(${heroImg})`,
      // }}
    >
      <Container wide={true}>
        <Styled.ContentContainer>
          <Styled.Title>
            {' '}
            <div className="pt-0 sm:pt-1"></div>
            <span className="font-primary text-left text-[#1f4b81] font-semibold pt-0">
              {t('landing.hero.title')}{' '}
            </span>
          </Styled.Title>
          {/* <Styled.Notification>
            {t('landing.hero.notification')}
          </Styled.Notification> */}
          {/* <Styled.Autocomplete>
            <Styled.InputHolder hasResults={!!Object.keys(results).length}>
              <SearchIcon />
              <Styled.Input
                type="text"
                value={query}
                onChange={(event) => {
                  const rawValue = event.target.value;
                  const filteredValue = rawValue.replace(
                    searchInputReplaceRegex,
                    '',
                  );
                  setQuery(filteredValue);
                }}
                style={{ color: '#52585F' }}
                placeholder={t('landing.hero.inputText')}
                onBlur={() => {
                  setTimeout(() => setQuery(''), 200);
                }}
                onKeyDown={(event) => {
                  if (event.key === 'Escape') {
                    setQuery('');
                  }
                }}
              ></Styled.Input>
              <Styled.RemoveXButton onClick={() => setQuery('')}>
                X
              </Styled.RemoveXButton>
              <Styled.Loader isLoading={fetchSearchResultsLoading}>
                <Loader size={22} color="#c5c5c5" inline />
              </Styled.Loader>
            </Styled.InputHolder>

            {!!Object.keys(results).length && (
              <Styled.Results>
                <Scrollbars>
                  <div style={{ padding: '12px 0' }}>
                    {Object.keys(results).map((key) => (
                      <div key={key}>
                        <Styled.ResultsGroupName>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: highlightText(key, query),
                            }}
                          ></div>
                        </Styled.ResultsGroupName>
                        {results[key].map((service, i) => (
                          <Styled.ResultsGroupItem
                            key={i}
                            primaryColor={theme.primaryColor}
                            onMouseDown={() => {
                              if (getAllowed().includes('analysis')) {
                                GAEventsTracker(
                                  'Paieškoje pasirinkta',
                                  getSearchSelectedTitleForGA(service),
                                );
                              }

                              let redirectUrl = '';
                              if (service.type === 'ServiceComplex') {
                                redirectToServicePage(service);
                              } else if (
                                service.serviceTypeExternalId !=
                                process.env.REACT_APP_SGKN_SERVICE_TYPE_EXT_ID
                              ) {
                                redirectUrl = `/order/${service.workplaceId}/${service.serviceId}`;
                              } else {
                                if (service.specialistId) {
                                  redirectUrl = `/services/${service.categoryId}/${service.serviceTypeId}?specialistId=${service.specialistId}`;
                                } else {
                                  redirectUrl = `/services/${service.categoryId}/${service.serviceTypeId}`;
                                }
                              }

                              if (!!redirectUrl) {
                                logUserSearchResultsSelection(
                                  service.serviceId,
                                  service.workplaceId,
                                  lastQuery,
                                  redirectUrl,
                                ).finally(() => {
                                  history.push(redirectUrl);
                                });
                              }
                            }}
                          >
                            {service.specialistName !== null && (
                              <div>
                                <div>
                                  <strong
                                    dangerouslySetInnerHTML={{
                                      __html: highlightText(
                                        service.specialistName,
                                        query,
                                      ),
                                    }}
                                  ></strong>
                                  <strong
                                    dangerouslySetInnerHTML={{
                                      __html: highlightText(
                                        ` - ${service.serviceTitle}`,
                                        query,
                                      ),
                                    }}
                                  ></strong>
                                </div>
                                <div>
                                  {service.specialty && isMobile && (
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: highlightText(
                                          `${service.specialty}`,
                                          query,
                                        ),
                                      }}
                                    />
                                  )}
                                </div>
                                <div style={{ display: 'flex' }}>
                                  {service.specialty && !isMobile && (
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: highlightText(
                                          `${service.specialty} - `,
                                          query,
                                        ),
                                      }}
                                    />
                                  )}

                                  <div
                                    style={{
                                      fontWeight: 'bold',
                                      marginLeft: '2px',
                                    }}
                                    dangerouslySetInnerHTML={{
                                      __html: highlightText(
                                        `&nbsp;${service.departmentName},`,
                                        query,
                                      ),
                                    }}
                                  />
                                  {service.departmentAddress && (
                                    <div
                                      style={{}}
                                      dangerouslySetInnerHTML={{
                                        __html: highlightText(
                                          `&nbsp;${service.departmentAddress}`,
                                          query,
                                        ),
                                      }}
                                    />
                                  )}
                                  {!service.hasUpcomingVisits && (
                                    <div
                                      style={{}}
                                      dangerouslySetInnerHTML={{
                                        __html: highlightText(
                                          isUltrasoundServiceType(service) &&
                                            service.workplaceTypeId ===
                                              'Tyrimas'
                                            ? '&nbsp;- Pagal poreikį atliekamas konsultacijos metu'
                                            : '&nbsp;- Nėra laisvų vizitų ',
                                          query,
                                        ),
                                      }}
                                    />
                                  )}
                                </div>
                              </div>
                            )}
                            {service.specialistName === null && (
                              <div>
                                <div>
                                  <strong
                                    dangerouslySetInnerHTML={{
                                      __html: highlightText(
                                        service.serviceTitle,
                                        query,
                                      ),
                                    }}
                                  ></strong>
                                </div>
                                {service.type !== 'ServiceComplex' && (
                                  <div style={{ display: 'flex' }}>
                                    <div
                                      style={{
                                        fontWeight: 'bold',
                                        marginLeft: '2px',
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: highlightText(
                                          ` ${service.departmentName}, `,
                                          query,
                                        ),
                                      }}
                                    />
                                    {service.departmentAddress && (
                                      <div
                                        style={{}}
                                        dangerouslySetInnerHTML={{
                                          __html: highlightText(
                                            `&nbsp;${service.departmentAddress} `,
                                            query,
                                          ),
                                        }}
                                      />
                                    )}
                                    {!service.hasUpcomingVisits && (
                                      <div
                                        style={{}}
                                        dangerouslySetInnerHTML={{
                                          __html: highlightText(
                                            '&nbsp;- Nėra laisvų vizitų',
                                            query,
                                          ),
                                        }}
                                      />
                                    )}
                                  </div>
                                )}
                              </div>
                            )}
                          </Styled.ResultsGroupItem>
                        ))}
                      </div>
                    ))}
                  </div>
                </Scrollbars>
              </Styled.Results>
            )}
            {query.length >= 3 &&
              !Object.keys(results).length &&
              allowShowEmptyResults && (
                <div
                  style={{
                    padding: '12px',
                    textAlign: 'center',
                    color: '#888',
                  }}
                >
                  {'Paieškos rezultatų nerasta.'}
                </div>
              )}
          </Styled.Autocomplete> */}
        </Styled.ContentContainer>
        <Search />
        <PopularSearches />
      </Container>
    </Styled.Hero>
  );
};

export default Hero;
